module.exports = __webpack_public_path__ + "img/1300f.934c07c9.png";